<div class="blank-wrapper">

  <router-outlet></router-outlet>

</div>
